"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateLeagueChannelMappingDto = instanceOfCreateLeagueChannelMappingDto;
exports.CreateLeagueChannelMappingDtoFromJSON = CreateLeagueChannelMappingDtoFromJSON;
exports.CreateLeagueChannelMappingDtoFromJSONTyped = CreateLeagueChannelMappingDtoFromJSONTyped;
exports.CreateLeagueChannelMappingDtoToJSON = CreateLeagueChannelMappingDtoToJSON;
exports.CreateLeagueChannelMappingDtoToJSONTyped = CreateLeagueChannelMappingDtoToJSONTyped;
/**
 * Check if a given object implements the CreateLeagueChannelMappingDto interface.
 */
function instanceOfCreateLeagueChannelMappingDto(value) {
    if (!('league_id' in value) || value['league_id'] === undefined)
        return false;
    if (!('youtube_channel_id' in value) || value['youtube_channel_id'] === undefined)
        return false;
    return true;
}
function CreateLeagueChannelMappingDtoFromJSON(json) {
    return CreateLeagueChannelMappingDtoFromJSONTyped(json, false);
}
function CreateLeagueChannelMappingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'league_id': json['league_id'],
        'youtube_channel_id': json['youtube_channel_id'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}
function CreateLeagueChannelMappingDtoToJSON(json) {
    return CreateLeagueChannelMappingDtoToJSONTyped(json, false);
}
function CreateLeagueChannelMappingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'league_id': value['league_id'],
        'youtube_channel_id': value['youtube_channel_id'],
        'priority': value['priority'],
        'reason': value['reason'],
    };
}
